import { Component } from '@angular/core';

@Component({
    selector: 'app-finance-management-list',
    templateUrl: './finance-management-list.component.html',
    styleUrls: ['./finance-management-list.component.scss']
})
/** finance-management-list component*/
export class FinanceManagementListComponent {
    /** finance-management-list ctor */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/app/finance-management/finance-management-list/finance-management-list.component.ts